import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";

class MdocSdocCardView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
    };
  }
  render() {
    const { pageSize, totalRecords, currentPage, arraylist } = this.props;

    return (
      <div className="pb-3" style={{ marginTop: "12px" }}>
        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          <Paginator
            first={(this.props.pageNumber - 1) * pageSize}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !--No Item to Display--!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, eyeclick } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div className="card" style={{ overflow: "hidden", position: "relative", marginTop: "2px" }}>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={"col-md-12 col-sm-12 col-12 col-m-auto"}>
                    <div className="row px-2">
                      <div className={showSidePane ? "col-sm-12 mb-1" : "col-sm-12 mb-1"}>
                        <h6 className="resource-list-title m-auto" >{item.poNumber} </h6>
                      </div>
                      <div className={showSidePane ? "col-md-4 mb-1" : "col-md-4"}>
                        <span><strong>MD Name : </strong><span className="italicFont ">{item?.mDocName} </span></span>
                      </div>
                      <div className={showSidePane ? "col-md-4 mb-1" : "col-md-4"}>
                        <span><strong>SDoC Name : </strong><span className="italicFont ">{item?.sDocName} </span></span>
                      </div>
                      <div className={showSidePane ? "col-md-4 mb-1" : "col-md-4"}>
                        <span><strong>Status : </strong><span className={`italicFont ${item.status == "Exception" ? "status-red" : item.status == "Pending" ? 'status-blue' : "status-green"}`}>{item?.status} </span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };


}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MdocSdocCardView)
);
